import type { LatLngLiteral, Map } from 'leaflet'
import { LatLngBounds } from 'leaflet'

const MAX_ZOOM = 14
const A4_PORTRAIT_SCREEN_WIDTH = 842

const useMapCenterToMarker = (mapInstance: Map | null) => {
  const panOrFitBounds = (
    boundOrLatLng: LatLngBounds | LatLngLiteral,
    offset: number = 0,
    opts: { animate?: boolean } = {},
  ) => {
    if (mapInstance) {
      if (boundOrLatLng instanceof LatLngBounds) {
        const boundsZoom = mapInstance.getBoundsZoom(boundOrLatLng)
        mapInstance.fitBounds(boundOrLatLng, {
          maxZoom: boundsZoom > MAX_ZOOM ? MAX_ZOOM : boundsZoom,
          paddingTopLeft: [offset, 0],
          animate: opts.animate ?? true,
        })
      } else {
        const { x, y } = mapInstance.latLngToContainerPoint(boundOrLatLng)
        // We have to subtract the position with a value that "pushes" the marker to the visual centre of the map
        // This value is calculated by dividing the drawerPanel width by 2
        const newLocation = mapInstance.containerPointToLatLng([x - offset / 2, y])
        mapInstance.panTo(newLocation)
      }
    }
  }

  const panToWithPanelOffset = (boundOrLatLng: LatLngBounds | LatLngLiteral) => {
    panOrFitBounds(boundOrLatLng)
  }

  const panToFitPrintMode = (boundOrLatLng: LatLngBounds | LatLngLiteral) => {
    const windowWidth = window.innerWidth
    if (windowWidth > A4_PORTRAIT_SCREEN_WIDTH) {
      panOrFitBounds(boundOrLatLng, (windowWidth - A4_PORTRAIT_SCREEN_WIDTH) * -1, {
        animate: false,
      })
    }
  }

  return {
    panToWithPanelOffset,
    panToFitPrintMode,
  }
}

export default useMapCenterToMarker
